import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ClientAssignmentSummary } from '../api/types';

export function resolveProductionClientId(
  requestedClientId: string | null,
  assignments: ReadonlyArray<ClientAssignmentSummary>,
): string | null {
  if (!requestedClientId) return null;
  return assignments.some(
    (assignment) =>
      assignment.client_id === requestedClientId && assignment.client_status !== 'archived',
  )
    ? requestedClientId
    : null;
}

export function useProductionClientSelection(assignments: ReadonlyArray<ClientAssignmentSummary>): {
  readonly selectedClientId: string | null;
  readonly setSelectedClientId: (clientId: string | null) => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedClientId = resolveProductionClientId(searchParams.get('client'), assignments);

  const setSelectedClientId = useCallback(
    (clientId: string | null) => {
      const next = new URLSearchParams(searchParams);
      if (clientId) next.set('client', clientId);
      else next.delete('client');
      setSearchParams(next);
    },
    [searchParams, setSearchParams],
  );

  return { selectedClientId, setSelectedClientId };
}
